import { render } from "./ToFactorAuth.vue?vue&type=template&id=05abc54c"
import script from "./ToFactorAuth.vue?vue&type=script&lang=js"
export * from "./ToFactorAuth.vue?vue&type=script&lang=js"
script.render = render

export default script